// src/components/geral/PageContainer.js
import React from 'react';
import './PageContainer.css';

const PageContainer = ({children, className = ''}) => {


  return (
    <div className={`page-container ${className}`.trim()}>
      {children}
    </div>
  );
};

export default PageContainer;
